<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="OT">Contents</p>
<p class="CON1" id="toc1"><a href="#/Gorman_Becoming_the_Gospel_text_CC6#_idTOCAnchor-2"><em>Acknowledgments</em></a></p>
<p class="CON1" id="toc2"><a href="#/Gorman_Becoming_the_Gospel_text_CC7#_idTOCAnchor-3">Invitation: Becoming the Gospel</a></p>
<p class="CON1" id="toc3"><a href="#/Gorman_Becoming_the_Gospel_text_CC8#_idTOCAnchor-4">1. Paul and the Mission of God</a></p>
<p class="CON1" id="toc4"><span href="#/Gorman_Becoming_the_Gospel_text_CC9#_idTOCAnchor-5" title="Link target outside of Sample">2. Reading Paul Missionally</span></p>
<p class="CON1" id="toc5"><span href="#/Gorman_Becoming_the_Gospel_text_CC10#_idTOCAnchor-6" title="Link target outside of Sample">3. Becoming the Gospel of Faith(fulness), <br/>Love, and Hope: 1 Thessalonians</span></p>
<p class="CON1" id="toc6"><span href="#/Gorman_Becoming_the_Gospel_text_CC11#_idTOCAnchor-7" title="Link target outside of Sample">4. Becoming and Telling the Story of Christ: Philippians</span></p>
<p class="CON1" id="toc7"><span href="#/Gorman_Becoming_the_Gospel_text_CC12#_idTOCAnchor-8" title="Link target outside of Sample">5. Becoming the Gospel of Peace (I): Overview</span></p>
<p class="CON1" id="toc8"><span href="#/Gorman_Becoming_the_Gospel_text_CC13#_idTOCAnchor-9" title="Link target outside of Sample">6. Becoming the Gospel of Peace (II): Ephesians</span></p>
<p class="CON1" id="toc9"><span href="#/Gorman_Becoming_the_Gospel_text_CC14#_idTOCAnchor-10" title="Link target outside of Sample">7. Becoming the Justice of God: 1 &amp; 2 Corinthians</span></p>
<p class="CON1" id="toc10"><span href="#/Gorman_Becoming_the_Gospel_text_CC15#_idTOCAnchor-11" title="Link target outside of Sample">8. Becoming the Gospel of God’s Justice/Righteousness and Glory: Missional Theosis in Romans</span></p>
<p class="CON1" id="toc11"><span href="#/Gorman_Becoming_the_Gospel_text_CC16#_idTOCAnchor-12" title="Link target outside of Sample">Final Reflections: Becoming the Gospel (Reprise)</span></p>
<p class="CON1" id="toc12"><span href="#/Gorman_Becoming_the_Gospel_text_CC17#_idTOCAnchor-13" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="CON1" id="toc13"><span href="#/Gorman_Becoming_the_Gospel_text_CC18#_idTOCAnchor-14" title="Link target outside of Sample"><em>Index of Subjects and Names</em></span></p>
<p class="CON1" id="toc14"><span href="#/Gorman_Becoming_the_Gospel_text_CC19#_idTOCAnchor-15" title="Link target outside of Sample"><em>Index of Scripture and Other Ancient Sources</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Gorman_Becoming_the_Gospel_text_CC5.vue?67d747fd